module.exports = __webpack_public_path__ + "media/images/emoticons/tennis-2270caacab0426aa94914ce2bf03146f.gif";